import { Component, OnInit, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-page-header',
    template: require('./page-header.component.html'),
    styles: [require('./page-header.component.css')]
})
export class PageHeaderComponent implements OnInit {
    @Input() heading: string;
    @Input() icon: string;
    @Input() parents: any;
    constructor() {
       
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/page-header/page-header.component.ts